.ugc-select-wrap {
  position: relative;
  width: 100%;
  height: 48px;
  user-select: none;

  label {
    position: absolute;
    top: 50%;
    @at-root [dir='ltr'] & {
      left: 10px;
    }
    @at-root [dir='rtl'] & {
      right: 10px;
    }
    margin-top: -10px;
    height: 20px;
    line-height: 20px;
    padding: 0 px;
    color: #666;
    background: #fff;
    transition: all linear 80ms;
    border-radius: 4px;
  }

  input {
    display: block;
    width: 100%;
    height: 100%;
    color: #999;
    transition: all linear 80ms;
    background: none;
    outline: none;
    border: 1px solid #ccc;
    border-radius: 8px;
    &:hover {
      border: 1px solid var(--green-dark);
    }
    &:focus {
      border: 1px solid var(--green-dark);
      outline: 2px solid rgba(0, 128, 0, 0.2); /* More visible focus outline */
    }
  }
  &.actived {
    label {
      margin-top: 0;
      top: -10px;
      color: #999;
      font-size: 12px;
      font-weight: normal;
      transform: scale(0.9);
    }
    input {
      color: #333;
      border: 1px solid #ccc;
      &:hover {
        border: 1px solid var(--green-dark);
      }
    }
    &:hover > label {
      color: var(--green-dark);
    }
  }
  &.selecting {
    label {
      margin-top: 0;
      top: -10px;
      color: var(--green-dark);
      font-size: 12px;
      font-weight: normal;
      transform: scale(0.9);
    }
    input {
      color: #333;
      border: 1px solid var(--green-dark);
      &:hover {
        border: 1px solid var(--green-dark);
      }
    }
  }
  &.actived.activing {
    label {
      margin-top: 0;
      top: -10px;
      color: var(--green-dark);
      font-size: 12px;
      font-weight: normal;
      transform: scale(0.9);
    }
    input {
      color: #333;
      border: 1px solid var(--green-dark);
      &:hover {
        border: 1px solid var(--green-dark);
      }
    }
  }

  .arrow-wrap {
    position: absolute;
    top: 12px;
    transition: 200ms;
    @at-root [dir='ltr'] & {
      right: 16px;
    }
    @at-root [dir='rtl'] & {
      left: 16px;
    }
  }
}
.select-item-wrap {
  position: absolute;
  padding: 4px 0;
  top: 52px;
  left: 0;
  z-index: -1;
  width: 100%;
  max-height: 500px;
  border-radius: 8px;
  box-shadow: 0 5px 5px -3px rgb(0 0 0/20%), 0px 8px 10px 1px rgb(0 0 0/14%), 0px 3px 14px 2px rgb(0 0 0/12%);
  background: #fff;
  transition: all linear 200ms;
  opacity: 0;
  overflow-y: auto;

  .select-item {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 8px 16px;
    color: #333;
    background: #fff;
    transition: all linear 80ms;
    &:hover,
    &.active {
      background-color: var(--green-light);
    }
    &.select-item-selected {
      background-color: var(--green-light);
    }
    &:focus {
      background-color: var(--green-light);
      box-shadow: inset 0 0 0 1px var(--green-dark);
    }
    &.select-item-active {
      background-color: var(--green-light);
    }
  }
  &.selecting.select-item-wrap {
    z-index: 1;
    opacity: 1 !important ;
  }
}
